import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { environment } from 'src/environments/environment';
import {BehaviorSubject} from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ShareService {
  private eventData: any;

  constructor(private http: HttpClient) {
  }

  isDetailSmartCode: BehaviorSubject<any> = new BehaviorSubject('');
  isDetailSmartCodeChanged = this.isDetailSmartCode.asObservable();
  
  isLngLat: BehaviorSubject<any> = new BehaviorSubject('');
  isLngLatChanged = this.isLngLat.asObservable();

  isCloseDetail: BehaviorSubject<any> = new BehaviorSubject('');
  isCloseDetailChanged = this.isCloseDetail.asObservable();

  isClosePanel: BehaviorSubject<any> = new BehaviorSubject('');
  isClosePanelChanged = this.isClosePanel.asObservable();

  isDireciton: BehaviorSubject<any> = new BehaviorSubject('');
  iisDirecitonOpen = this.isDireciton.asObservable();

  isCloseShare: BehaviorSubject<any> = new BehaviorSubject('');
  isCloseShareEvent = this.isCloseShare.asObservable();

  isDetailMarker:BehaviorSubject<any> = new BehaviorSubject('');
  isDetailMarkerEvent=this.isDetailMarker.asObservable();

  isCloseSave:BehaviorSubject<any> = new BehaviorSubject('');
  isCloseSaveEvent=this.isCloseSave.asObservable()

  isCloseLocations:BehaviorSubject<any> = new BehaviorSubject('');
  isCloseLocationEvent=this.isCloseLocations.asObservable()

  isShareLocation:BehaviorSubject<any> = new BehaviorSubject('');
  isShareLocationEvent=this.isShareLocation.asObservable()


  router:BehaviorSubject<any> = new BehaviorSubject('');
  routerEvent=this.router.asObservable()

  isShareDataSearch:BehaviorSubject<any> = new BehaviorSubject<any>(null);
  isShareDataSearchEvent= this.isShareDataSearch.asObservable()

  
  shareDetailSmartCode(e){
    this.isDetailSmartCode.next(e);
  }
  shareLngLat(lng: any, lat: any){
    const coordinates = { lng: lng, lat: lat };
    this.isLngLat.next(coordinates);
  }
  closeDetail(e){
    this.isCloseDetail.next(e);
  }
  closePanel(e){
    this.isClosePanel.next(e);
  }
  directionFromPanel(e){
    this.isDireciton.next(e)
  }
  closeShare(e){
    this.isCloseShare.next(e)
  }
  shareDetailMarker(e){
    this.isDetailMarker.next(e)
  }
  closeSavePanel(e){
    this.isCloseSave.next(e)
  }
  closeLocation(e){
    this.isCloseLocations.next(e)
  }
  shareLocation(e){
    this.isShareLocation.next(e);
  }
  routerPage(e){
    this.router.next(e)
  }
  shareSearch(data: any){
    this.isShareDataSearch.next(data)
  }
  // setEventData(data: any) {
  //   this.eventData = data;
  //   console.log(`eventData`,this.eventData);
  // }
  // getEventData() {
  //   console.log('getData', this.eventData);
  //   return this.eventData;
  // }
}
